<template>
    <el-dialog title="添加管理员" append-to-body :visible.sync="addModuleDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">

            <el-form-item v-if="module_show" label="管理员类型" prop="module_type" class="label-bold">
                <el-radio-group v-model="formData.module_type">
                    <el-radio :disabled="module_disabled" :label="1">主管理员
                       <el-tooltip v-if="moduleAdminUser" class="item" effect="dark" :content="'已选'+ moduleAdminUser + '，如需更换请先移除'" placement="top-start">
                         <span>({{moduleAdminUser}}) </span>
                       </el-tooltip>
                    </el-radio>
                    <el-radio :label="2">子管理员</el-radio>
                </el-radio-group>
            </el-form-item>


            <el-form-item :label="formData.module_type == 1 ? '选择管理员' : '选择子管理员'" prop="user_id">
                <el-select v-model="formData.user_id" :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择人员，可输入人员姓名搜索"  remote  size="small">
                    <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    v-for="user in userList">
                    </el-option>
                </el-select>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetUserList,addModuleAdmin,addSubModuleAdmin } from "@/api/index.js"
import {mapState} from "vuex";
export default {
    name:'add_sub_admin',
    props: {
        addModuleDialog: {
            type: Boolean,
            default: false
        },
        moduleName: {
            type: String,
            default: ''
        },
        moduleAdminUser: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                module_type:1,
                user_id: "",
            },
            formRules: {
                user_id: [ {required: true, message: "请选择人员"} ]
            },
            userList:[],
            module_disabled:false,
            module_show:false
        }
    },
    computed: {

        ...mapState(['userInfo'])
    },
    created() {
        this.getUserList()
        let is_company_admin = this.userInfo.user.is_company_admin // 是否为系统管理员
        let is_system_sub_admin = this.userInfo.user.is_system_sub_admin // 是否为系统子管理员
        if(this.moduleAdminUser){
            this.module_disabled = true
            this.formData.module_type = 2
        }
        if(is_company_admin || is_system_sub_admin){
            this.module_show = true
        }

    },
    methods: {
        //获取用户列表
        getUserList(keyword) {
            GetUserList({keyword}).then(res => {
                if (res.code === 200) {
                    this.userList = res.data || []
                } else {
                    this.$toast(res.message)
                }
            })
        },
        handleDialogClose() {
            this.$emit("update:addModuleDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = {
                        module_name: this.moduleName,
                        user_id: this.formData.user_id
                    }
                    if(this.formData.module_type == 1){
                        addModuleAdmin(postData).then(res=> {
                            if(res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.handleDialogClose()
                                        this.$emit('success')
                                        this.BtnDisabled = false
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }else{
                        addSubModuleAdmin(postData).then(res=> {
                            if(res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功',
                                    duration: 1500,
                                    onClose: () => {
                                        this.handleDialogClose()
                                        this.$emit('success')
                                        this.BtnDisabled = false
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }


                }
            })
        },

    }
}
</script>
